<template>
  <Modal :id="'cmp-accounting-costs-add_booking'" @cancelled="onCancel">
    <template slot="header"> {{ $t("booking") }} </template>
    <template slot="body">
      <v-layout row wrap>
        <v-flex style="padding-right: 5px" xs6>
          <div class="label_box txtov">{{ $t("artist") }}</div>
          <div>
            <Dropdown
              :id="'artist_id'"
              class="dt-dropdown"
              :options="artistsTV"
              :selected="artistsTV.find((b) => b.value == filter.artist_id)"
              :placeholder="$t('select_artist')"
              deselect
              box
              v-on:selectedChange="
                (e) => onFilterDropdownChange('artist_id', e)
              "
            ></Dropdown>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="label_box txtov">{{ $t("period") }}</div>
          <div>
            <Dropdown
              :id="'month_val'"
              class="dt-dropdown"
              :options="periodsTV"
              :selected="periodsTV.find((b) => b.value == filter.month_val)"
              :placeholder="$t('select_period')"
              deselect
              box
              v-on:selectedChange="
                (e) => onFilterDropdownChange('month_val', e)
              "
            ></Dropdown>
          </div>
        </v-flex>
      </v-layout>
      <SearchList
        :id="'artists'"
        :items="items"
        :keyProperty="'artist_id'"
        :label="'artist_name'"
        :placeholder="'Search'"
        :selectionNumber="'radio'"
        :isSearchable="false"
        :headers="[
          {
            text: $t('start_date'),
            value: 'start_date',
          },
          {
            text: $t('artist'),
            value: 'artist_name',
          },
          {
            text: $t('location'),
            value: 'booking_location_name',
          },
          {
            text: $t('city'),
            value: 'city',
          },
          {
            text: $t('country'),
            value: 'country',
          },
        ]"
      >
        <template v-slot:item="{ item }">
          <tr class="dt-table2--row" @click="onContactItemClick(item)">
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.start_date }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.artist_name }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.booking_location_name }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.city }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.country }}</span>
            </dt>
          </tr>
        </template>
      </SearchList>
      <div class="form-group">
        <TextField
          :id="'description'"
          v-bind="textFieldConfig"
          :placeholder="$t('description')"
          required
          showValidationIcons
          @valuechanged="onTextFieldValueChange"
          v-model="newData.description"
          @validated="onValidation"
        ></TextField>

        <div class="amount-container">
          <TextField
            :id="'amount'"
            @valuechanged="onTextFieldValueChange"
            v-bind="textFieldConfig"
            :placeholder="$t('amount')"
            @validated="onValidation"
            required
            class="m1 input_box"
            type="text"
            showValidationIcons
            v-model="newData.amount"
          ></TextField>

          <span class="currency">{{ selectedCostsDetails.currency_iso }}</span>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 with-ico s6"
        @click.stop="onClickOK"
      >
        <div class="button-text">
          {{ $t("ok") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import { CostsService } from "../../services/costs.service";
import Modal from "@dtplugins/modal/modal";
import { createTV, tv } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      filter: {
        artist_id: null,
        month_val: null,
      },
      validationResult: {},
      bookingData: {},
      newData: {
        description: "",
        amount: "",
        external_id: 0,
      },
      bookings: [],
      invoiceDateMenu: null,
      selectedBooking: new Set(),
    };
  },
  mounted: function () {
    //this.getBookings();
    this.getAddBookingData();
  },
  watch: {},
  computed: {
    items: function () {
      return this.bookings || [];
    },

    isFormValid: function () {
      return this.newData.description && this.newData.amount;
    },
    artistsTV: function () {
      return createTV(this.bookingData?.artists, "artist_name", "artist_id");
    },
    periodsTV: function () {
      return this.bookingData?.periods
        ? this.bookingData?.periods.map((e) => ({
            text: `${e.month} ${e.year}`,
            value: e.month_val,
          }))
        : [];
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onCancel() {
      this.$emit("cancelled");
    },
    async getAddBookingData() {
      const res = await CostsService.findCostSplitAddBookings(
        this.selectedCostsDetails?.invoice?.invoice_id
      );
      this.bookingData = res.data;
      this.bookings = res.data?.bookings;
      this.newData.description = res.data?.invoice?.subject;
    },
    getBookings() {
      CostsService.searchCostSplitAddBookings(
        this.filter.artist_id,
        this.filter.month_val
      ).then((res) => {
        this.bookings = res.data.bookings;
      });
    },
    onClickOK() {
      let params = {
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        external_table: "calendar_date_costs",
        description: this.newData.description,
        amount: this.newData.amount,
        external_id: this.newData.external_id,
      };

      CostsService.addNewCostSplit(params).then((res) => {
        this[ActionTypes.AccountingCostSplits.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          cost_splits: res.data.cost_splits || [],
        });
        this.onCancel();
      });
    },

    onContactItemClick: function (booking) {
      this.newData.external_id = booking.artist_id;
      if (booking) {
        let subject =
          booking.start_date +
          "/" +
          booking.artist_name +
          "/" +
          booking.city +
          "/" +
          booking.booking_location_name;

        this.newData.description = subject;
      }
    },
    onValidation: function (id, validationResult) {
      // console.log(id, validationResult);
    },
    onTextFieldValueChange: function (name, value) {
      this.newData[name] = value;
      console.log("newData", this.newData);
    },
    onDropdownChange: function (name, value) {
      this.newData[name] = value.value;
    },
    onFilterDropdownChange: function (name, value) {
      this.filter[name] = value.value;
      this.getBookings();
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-add_booking {
  .dt-table2 {
    --body-height: 200px !important;
  }
  padding: 40px 55px 30px !important;
  .amount-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .currency {
      position: absolute;
      right: 4px;
      text-align: center;
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
  .dt-input-box--container {
    flex: 1;
    margin: 2px 2px 12px 0px !important;
  }
}
</style>
